import React from "react";
import CRUDManager from "../../../../shared/components/crud/CRUDManager";
import { vaccinationPlanConfig } from "../config/vaccinationPlanConfig";

export default function VaccinationPlan() {
  return <CRUDManager config={vaccinationPlanConfig} />;
}
